'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var sizes = exports.sizes = {
  XS: 'XS',
  SM: 'SM',
  MD: 'MD',
  LG: 'LG',
  XL: 'XL'
};

var DEFAULT_MIN_ADJUSTMENT = exports.DEFAULT_MIN_ADJUSTMENT = 10;
var DEFAULT_SIZE = exports.DEFAULT_SIZE = sizes.XS;
var DEFAULT_THROTTLE_MS = exports.DEFAULT_THROTTLE_MS = 250;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-container/dist/constants.js
// module id = 688
// module chunks = 2